import { Subject, Observable, of, from, Subscription } from 'rxjs';
import { FourDService } from './4d-mapper.service';
import { Account, Folder,Dataset, TransformType, Transform, PlottableModel, Annotation, TransformGroup} from './4d-objects';
import { MapHelper } from './4d-helper';
import {  TerrainRenderer, KMLRenderer, TMSRenderer, ThreeDTileRenderer, PhotoRenderer, LASRenderer } from './renderers/cesium-renderers-layer';
import { LegacyAnnotationRenderer, BlankAnnotationRenderer } from './renderers/cesium-renderers-annot';
import { ArcGisTransformRenderer } from './renderers/cesium-renderer-arcgis';
import { WMSTransformRenderer } from './renderers/cesium-renderer-wms';
import { WFSTransformRenderer } from './renderers/cesium-renderer-wfs';
import { WMTSTransformRenderer } from './renderers/cesium-renderer-wtms';

var Cesium = window['Cesium']

/**
 * <p>Helper class for <a href="https://cesiumjs.org/tutorials/">Cesium</a>. Contains methods to zoom to a location and add/remove a model to the map.</p>
 * <p>You can play with a(n) (<a href="https://stackblitz.com/edit/4dmapper-sdk">angular</a> or <a href="https://stackblitz.com/edit/react-demo-cesium">react</a>) demo on stackblitz.</p>
 */
export class FourdCesiumHelper extends MapHelper{
	//annotations:any
	
	//TP = Cesium.CesiumTerrainProvider
	
	//show = true

	private _originalTerrainProvider:any


	dziDatasource:any

	annotationDataSource:any
	annotationLabels:any

	constructor(public fourdD:FourDService,public viewer:any,cesiumObject?:any){
		super()
		if(cesiumObject)
			Cesium = cesiumObject
		else if(!Cesium)
			Cesium = window['Cesium']

    	//this.annotations = this.viewer.scene.primitives.add(new Cesium.LabelCollection());
   		this.dziDatasource = new Cesium.CustomDataSource('dzi');
		this.annotationDataSource = new Cesium.CustomDataSource('annot');

		this.annotationLabels = this.viewer.scene.primitives.add(new Cesium.LabelCollection());
   
		//this.viewer.dataSources.add(this.dataSource)
		this.viewer.dataSources.add(this.dziDatasource)
		this.viewer.dataSources.add(this.annotationDataSource)
		this._originalTerrainProvider = viewer.scene.terrainProvider;

		this.registerRenderer(Transform,'terrain', new TerrainRenderer(this))
		this.registerRenderer(Transform,'terrain-tiles', new TerrainRenderer(this))

		this.registerRenderer(Transform,'kml', new KMLRenderer(this))
		this.registerRenderer(Transform,'geo-json', new KMLRenderer(this))

		this.registerRenderer(Transform,'tms', new TMSRenderer(this))
		this.registerRenderer(Transform,'three-d-tiles', new ThreeDTileRenderer(this))
		this.registerRenderer(Transform,'photo-dzi', new PhotoRenderer(this))
		this.registerRenderer(Transform,'thumb', new PhotoRenderer(this))

		this.registerRenderer(Transform,'laz', new LASRenderer(this))

		this.registerRenderer(Transform,'arcgis-remote',new ArcGisTransformRenderer(this.viewer))
		this.registerRenderer(Transform,'wms-remote',new WMSTransformRenderer(this.viewer))
		this.registerRenderer(Transform,'wfs-remote',new WFSTransformRenderer(this.viewer))
		this.registerRenderer(Transform,'wmts-remote',new WMTSTransformRenderer(this.viewer))

		
		this.registerRenderer(Annotation,'*', new BlankAnnotationRenderer(this))

	}
	destroy(){
		super.destroy()
		this.viewer.dataSources.remove(this.annotationDataSource)
		this.viewer.dataSources.remove(this.dziDatasource)
	}
	
	/**
	 * <p>Returns the respective CesiumPlottableReference object of a given [[PlottableModel]] object</p>
	 * @param p [[PlottableModel]] object
	 * @deprecated use #getMapObjectFor instead
	 */
	getCesiumObjectFor(p:PlottableModel<any>){
		var plot = this.getMapObjectFor(p)
		if(plot)
			return plot.object
		else
			return null
	}

	clearPlottables(){
		Object.keys(this.plotCache).forEach(k => this.removePlottable(this.plotCache[k].plottable))
	}


	sendCameraTo(t:PlottableModel<any> , duration:number=500, args?:any):Observable<any>{
		var proj = this.plotCache['_' + t.className() + '_' + t.id]

		if(proj && proj.boundingSphere)
                this.viewer.camera.flyToBoundingSphere(proj.boundingSphere);

		else if(proj && proj.position)
			this.viewer.camera.flyTo({
				destination:proj.position,
				duration:duration/1000
			})

		else if(t instanceof Annotation && t.camera){
		 
			this.viewer.camera.flyTo({
				destination: Cesium.Cartographic.toCartesian(
					Cesium.Cartographic.fromDegrees(t.camera.position.lng,t.camera.position.lat,t.camera.position.height)
				),
				duration:duration/1000,
				orientation: {
					heading : Cesium.Math.toRadians(t.camera.direction.heading),
					pitch :  Cesium.Math.toRadians(t.camera.direction.pitch),
					roll :  Cesium.Math.toRadians(t.camera.direction.roll)
				}
			})
          
		}
		else if(t instanceof Transform && t.transformType && (t.transformType.uid == 'photo-dzi' || t.transformType.uid == 'thumb')){


			var dest = null
			if(args && args.vertical_invert){
				var v = t.cartographic()
				v.height = args.vertical_invert - v.height
				dest = Cesium.Cartographic.toCartesian(v)
			}
			else{
				dest = t.catresian()
			}

			var ori = t.heading != undefined && t.pitch != undefined && t.roll != undefined && (args && !args.ignoreOrientation)?
				{
			        heading : Cesium.Math.toRadians(t.heading),
			        pitch :  Cesium.Math.toRadians(t.pitch),
			        roll :  Cesium.Math.toRadians(t.roll)
			    }:
			    {	heading : Cesium.Math.toRadians(0),
			        pitch :  Cesium.Math.toRadians(-90),
			        roll :  Cesium.Math.toRadians(0)
			    }
			this.viewer.camera.flyTo({
				destination:dest,
				orientation: ori
			})
		}

		else if(t instanceof Annotation){
			var c = t.cartographic()
			c.height = 1000
			this.viewer.camera.flyTo({
				destination: Cesium.Cartographic.toCartesian(
				c
				),
				duration:duration/1000
			})
          
		}

		else{

			this.viewer.camera.flyTo({
				destination:t.rectangle(),
				duration:duration/1000
			})

		}
		var delaySubject = new Subject()
		setTimeout(() => delaySubject.next(this.viewer.camera),duration + 100)
		return delaySubject.asObservable()
	}

	/**
	 * <p>If the server supports it, get a token suffix that may be a remote storage server (eg S3 or Cloudfront URL)
	 * Cesium can query resources directly rather than hit application server</p>
	 * @param p [[PlottableModel]] Object
	 * @param file Name of file
	 * @param tier Applicable when Cloudfront is set up. Cesium allows request from one url at a time, so by providing a 'tier' which represents a different url, we can better conduct traffic. 0: default/Terrain Tiles, 1: Tile Map Service (tms), 2: 3D Tiles
	 */
	getAuthenticatedUrl(p:PlottableModel<any>,file:string,tier:number = 0): Promise<string>{
		return fetch(p.file('DIRECT_TOKEN_URL') + '&tier=' + tier)
			.then(r => r.json())
			.then(r => {
				var url = p.file(file) 
				if(r.status == 200 && r.payload.url && r.payload.prefix){
					var array = r.payload.url.split('?')
					if(array.length == 2){
						url = array[0] + r.payload.prefix.replace(/\*/g,'') + file + '?' + array[1]
					}

				}
				return url
			})
	}


  changeOpacity(t: Transform, opacity: number) {
  	// opacity doesnt work for terrain and laz
    if (t.ds_type_uid !== 'laslaz' && t.ds_type_uid !== 'terrain-tiles') {

      var obj = this.getCesiumObjectFor(t)
      
      if (!obj) throw new Error("Plotted object not found for " + t.id);

    
      if (t.ds_type_uid  === 'geo-json' || t.ds_type_uid  === 'kml' || t.ds_type_uid  === 'shape-zip' && obj._entityCollection) {

        obj._entityCollection.values.forEach(e => {
        
          if (e.polyline && e.polyline.material && e.polyline.material.color) {
            var color = new Cesium.Color(e.polyline.material.color._value.red, e.polyline.material.color._value.green, e.polyline.material.color._value.blue, opacity);
            e.polyline.material.color = color;
          } else if (e.polygon && e.polygon.material && e.polygon.material.color) {
            var color = new Cesium.Color(e.polygon.material.color._value.red, e.polygon.material.color._value.green, e.polygon.material.color._value.blue, opacity);
            e.polygon.material.color = color;

            if (opacity == 1) {
              e.polygon.outline = true;
            } else {
              e.polygon.outline = false;
            }
          }
        })
      }

      obj.alpha = opacity
      obj.style = new Cesium.Cesium3DTileStyle({
        color: 'rgba(255, 255, 255,' + obj.alpha + ')'
      });

    }
  }

  resolveItem(movement){
  	var feature = this.viewer.scene.pick(movement.position);
    var def = Cesium.defined(feature);
  
    if (def && feature.id && feature.id.transform_id) {
    	return this.plotCache['_Transform_' + feature.id.transform_id].plottable
    }
    if (def && feature.id && feature.id.entityCollection && feature.id.entityCollection.transform_id) {
    	return this.plotCache['_Transform_' + feature.id.entityCollection.transform_id].plottable
	}
    if (def && feature.primitive && feature.primitive.transform_id) {
      	return this.plotCache['_Transform_' + feature.primitive.transform_id].plottable
	}
    if (def && !feature.content && feature.id && feature.id.fourd_ref) {
      	return this.plotCache['_Annotation_' + feature.id.fourd_ref].plottable
	}
	if (def && !feature.content && feature.primitive) {
		var f = null
		Object.keys(this.plotCache).find(k => {
			if(this.plotCache[k].object == feature.primitive){
				f = this.plotCache[k].plottable
				return true
			}
		});
		return f
 	}
  }
}

